import { api } from "./api";

// GET: RoomId 조회 by adminId and otherId
export const getRoomIdApi = (user1Id, user2Id) => api.get(`/chat/room/id?user1Id=${user1Id}&user2Id=${user2Id}`)

// GET: 채팅 유저리스트 조회
export const getChatUserListApi = (userId,isAdmin) => api.get(`/chat/userlist/${userId}?isAdmin=${isAdmin}`)